import { createWithEqualityFn } from 'zustand/traditional';
import { devtools } from 'zustand/middleware';
import { shallow } from 'zustand/shallow';
import { persist, createJSONStorage } from 'zustand/middleware';

import { BaseStore } from '../BaseStore';

/**
 * @typedef {Object} WebAppSettingsStoreState - creates a new type named 'WebAppSettingsStoreState'
 * @property {Object} developer - todo
 * @property {boolean} developer.inspect - todo
 * @property {Object} theme - todo
 */

// issues because of localStorage
// if you add something in a nested object its undefined because it gets overwritten by localStorage
export class WebAppSettingsStore extends BaseStore {
  createInitialState() {
    return {
      developer: {
        inspect: false,
      },
      theme: {
        darkMode: false,
        prevDarkMode: null,
        reducedMotion: false,
      },
    };
  }

  store = createWithEqualityFn(
    persist(
      devtools(
        (set, get, api) => ({
          ...this.createInitialState(),
        }),
        {
          name: 'app-settings',
        }
      ),
      {
        name: 'app-settings',
        storage: createJSONStorage(() => localStorage),
      }
    ),
    shallow
  );

  toggleDarkMode() {
    const state = this.get();

    this.set({
      theme: {
        ...state.theme,
        darkMode: !state.theme.darkMode,
      },
    });
  }

  disableDarkMode() {
    const state = this.get();

    this.set({
      theme: {
        ...state.theme,
        darkMode: false,
        prevDarkMode: state.theme.darkMode,
      },
    });
  }

  restoreDarkMode() {
    const state = this.get();

    this.set({
      theme: {
        ...state.theme,
        darkMode: state.theme.prevDarkMode,
        prevDarkMode: null,
      },
    });
  }
}

export const webAppSettingsStore = new WebAppSettingsStore();

// Was this not to pollute localStorage or something?
export class WebAppSettingsStoreTemp extends BaseStore {
  createInitialState() {
    return {
      isFullscreen: false,
    };
  }

  store = createWithEqualityFn(
    devtools(
      (set, get, api) => ({
        ...this.createInitialState(),
      }),
      { name: 'app-settings-temp' }
    ),
    shallow
  );

  enableFullscreen() {
    this.set({
      isFullscreen: true,
    });
  }

  disableFullscreen() {
    this.set({
      isFullscreen: false,
    });
  }
}

export const webAppSettingsStoreTemp = new WebAppSettingsStoreTemp();
